import {MAP_DEFAULT_POSITION} from "@/config/const";

export default {
  /**
   * 装置が異常値かどうかを判定する
   * @param {String} status ステータス
   * @returns {Boolean} 異常値かどうか undefinedのものは false を返す
   */
  isAbnormalMachinery(status) {
    if(typeof status === "undefined" || status == null){
      return false
    }
    return (status.trim().includes("*") || status.trim().includes("S"))
  },

  /**
   * ステータスがイベントかどうか判定する
   * @param {String} status ステータス
   * @returns {Boolean} イベントかどうか undefinedのものは false を返す
   */
  isEventStatus(status) {
    if(typeof status === "undefined" || status == null){
      return false
    }
    return status.trim().includes("E")
  },
  getCoordinatesByChannelData(channelData){
    let latitude
    let longitude
    if (channelData.SB03.vn === null) {
      if (channelData.SB08.vn === null) {
        latitude = MAP_DEFAULT_POSITION.center[1]
        longitude = MAP_DEFAULT_POSITION.center[0]
      } else {
        latitude = channelData.SB07.vn
        longitude = channelData.SB08.vn
      }
    } else {
      latitude = channelData.SB02.vn
      longitude = channelData.SB03.vn
    }
    return [latitude, longitude]
  },
  getVesselInfoByChannelData(channelData) {
    let coordinates = this.getCoordinatesByChannelData(channelData);
    return {
      operationMode: channelData.SB44.vs,
      steeringMode: channelData.SB29.vs,
      maneuveringMode: channelData.SB30.vs,
      latitude: coordinates[0],
      longitude: coordinates[1],
      vesselHeading: channelData.SB11.vn,
      speedOverGroundPrecise: channelData.SB05.vn,
      distanceFromBowToBerth: channelData.SB45.vn,
      distanceFromSternToBerth: channelData.SB46.vn,
      datetime: channelData.SB02.timestamp
    };
  },
};
